import { Box, Text } from '@chakra-ui/react';

export const TextareaPreview = () => {
  return (
    <Box>
      <Text>TextareaPreview - Coming soon</Text>
    </Box>
  );
};
